import { useDebouncedValue } from "@mantine/hooks"
import { PaginationState } from "@tanstack/react-table"
import { useEffect, useState } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"
import { translationFiltersSchema } from "@tfg/types/schemas/admin"

import { useSearchParamsFilters } from "~/components/hooks/useSearchParamsFilters"

import { TranslationsAdmin } from "./TranslationsAdmin"
import { useListTranslations } from "./hooks"

const DEFAULT_PAGE_SIZE = 50
export const TranslationsAdminWrapper = () => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  })
  const [translationsData, setTranslationsData] =
    useState<AdminResponses.TranslationWithTotal>({
      translations: [],
      total: 0,
    })

  const [searchParams] = useSearchParamsFilters(translationFiltersSchema)

  const [debouncedSearchParams] = useDebouncedValue<string>(
    searchParams.search,
    600
  )

  const { data: translationsDataFetched, isFetching } = useListTranslations({
    pagination: {
      page: pagination.pageIndex,
      pageSize: pagination.pageSize,
    },
    searchParams: debouncedSearchParams,
  })

  useEffect(() => {
    if (translationsDataFetched) {
      setTranslationsData(translationsDataFetched)
    }
  }, [translationsDataFetched])

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedSearchParams])

  return (
    <TranslationsAdmin
      components={translationsData.translations}
      isFetching={isFetching}
      pagination={pagination}
      setPagination={setPagination}
      translationsTotal={translationsData.total}
    />
  )
}
